import React, { Component } from "react";
import "./stylesheets/jobview.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackJobs,
  getBackJobsEdit,
  getBackSiteid,
  getUpdateJob,
  getBackJobDates,
  getBackJobsAuth,
  getJobLog,
  getTechniciansJob,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import {
  Button,
  Offcanvas,
  Spinner,
  Form,
  FloatingLabel,
  Dropdown,
  Alert,
} from "react-bootstrap";

export default class JobView extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.timeInput = React.createRef();
    this.remarkInput = React.createRef();
    this.state = {
      currnetmonthdata: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      show: false,
      scroll: false,
      backdrop: false,
      submitbtn: false,
      name: "Job",
      placement: "end",
      customer: "",
      showMaterial: [],
      techDataMain: "",
      customerJob: "",
      customerDate: "",
      TechnicianName: ["Technician(s) *"],
      statusId: "10",
      selectedStatus: "Created",
      siteId: 0,
      selectedSite: "Site Id",
      listSiteId: "",
      jobdetails: [],
      dateArr: [],
      expanded: [],
      jobLogs: [],
      JobID: "",
      SiteID: "",
      CustomerID: "",
      JobTypeID: "",
      JobDuration: "",
      StartDateTime: "",
      EndDateTime: "",
      Department: "",
      ModifiedDate: "",
      ConveyorReference: "",
      Remarks: "",
      NumberOfCasuals: "",
      Technicians: "",
      TechniciansCheck: "",
      TechniciansData: "",
      IncludeMtrl: "",
      OnlyCasuals: "",
      Factory: "",
      UG: "",
      Stage: "",
      Status: "",
      submitvalue: "",
      errorClass: "duration_data",
      measuresData: "",
      materialsData: "",
      measuresdatamainone: "",
      measuresdatamaintwo: "",
      measuresdatamainthree: "",
      measuresdatamainfour: "",
      measuresdatamainfive: "",
      measuresdatamainsix: "",
      materialsdatamainone: "",
      materialsdatamaintwo: "",
      materialsdatamainthree: "",
      materialsdatamainfour: "",
      materialsdatamainfive: "",
      materialsdatamainsix: "",
      materialsdatamainwone: "",
      materialsdatamainwtwo: "",
      materialsdatamainwthree: "",
      materialsdatamainwfour: "",
      materialsdatamainwfive: "",
      materialsdatamainwsix: "",
      materials: [],
      measures: [],
      loadingData: "No data found",
      isError: {
        StartDateTime: "",
        EndDateTime: "",
        duration: "",
        Department: "",
        ConveyorReference: "",
        NumberOfCasuals: "",
        TechnicianName: "",
        Remarks: "",
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;

      const responseDates = await getBackJobDates(sendData);
      const datarespDates = await responseDates;

      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }

      var dateArr = [];
      for (var i = 0; i < datarespDates.length; i++) {
        var dateData = new Date(datarespDates[i].CalendarDate);
        dateArr.push(dateData);
      }

      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
        dateArr: dateArr,
      });
    };
    fetchsiteid();
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        this.setState({
          statusId: "10",
          selectedStatus: "Created",
          Permission: filteredData[0].PermissionCode,
        });
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        this.setState({
          statusId: "60",
          selectedStatus: "Validated",
          Permission: filteredData[0].PermissionCode,
        });
      }
    } else {
      this.setState({
        statusId: "10",
        selectedStatus: "Created",
        Permission: "",
      });
    }
    //  document.addEventListener('scroll', () => {
    //   const isTop = window.scrollY < 460;
    //     console.log('isTop',window.scrollY)
    //   if (isTop !== this.state.isTop) {
    //       // this.setState({ isTop })
    //   }
    // });
  }

  handleBtnClick = (event) => {
    this.setState({
      Remarks: "",
      isError: {
        StartDateTime: "",
        EndDateTime: "",
        duration: "",
        Department: "",
        ConveyorReference: "",
        NumberOfCasuals: "",
        TechnicianName: "",
      },
    });
    var customerJob = event.JobID;
    var sendData = { jobid: event.JobID };
    var workData = JSON.parse(localStorage.getItem("workData"));
    const fetchjobedit = async () => {
      const responsejobs = await getBackJobsEdit(sendData);
      const datarespjobs = await responsejobs;

      this.setState({
        showMaterial: datarespjobs.Materials,
      });

      var materialsData = "";
      var measuresData = "";
      if (datarespjobs.JobTypeID !== "") {
        const responseTech = await getTechniciansJob(sendData);
        // const datarespjobs = await responsejobs;

        const filtered = workData.filter((obj) => {
          return obj.JobTypeID === datarespjobs.JobTypeID;
        });
        var startDateData = new Date(datarespjobs.StartDateTime);
        var startDate = Moment(startDateData).format("DD-MMM-YYYY");
        var customer = event.CustomerName;
        var JobType = event.JobType;
        var customerDate = event.JobType + " - " + startDate;
        var materialsDataList = filtered[0].Materials;
        var measuresDataList = filtered[0].Measures;
        var measuresDataArr = [];
        var materialsDataArr = [];
        var measuresDataArrValue = [];
        var materialsDataArrValue = [];
        var Measures = datarespjobs.Measures;
        var Materials = datarespjobs.Materials;
        for (var i = 0; i < measuresDataList.length; i++) {
          var WorkList = {};
          var WorkMeasures = {};
          WorkList = measuresDataList[i];
          if (
            parseInt(Measures[i]?.WorkMeasureMaterialID) ===
            parseInt(measuresDataList[i]?.WorkMeasureMaterialId)
          ) {
            WorkList.value = Measures[i].Value;
            WorkList.JobMeasureMaterialID = Measures[i].JobMeasureMaterialID;
            WorkMeasures["WorkMeasureMaterialID" + i] =
              Measures[i].WorkMeasureMaterialID;
            WorkMeasures["JobMeasureMaterialID" + i] =
              Measures[i].JobMeasureMaterialID;
            WorkMeasures["value" + i] = Measures[i].Value;
            if (i === 0) {
              this.setState({ measuresdatamainone: Measures[i].Value });
            } else if (i === 1) {
              this.setState({ measuresdatamaintwo: Measures[i].Value });
            } else if (i === 2) {
              this.setState({ measuresdatamainthree: Measures[i].Value });
            } else if (i === 3) {
              this.setState({ measuresdatamainfour: Measures[i].Value });
            } else if (i === 4) {
              this.setState({ measuresdatamainfive: Measures[i].Value });
            } else if (i === 5) {
              this.setState({ measuresdatamainsix: Measures[i].Value });
            }
          } else {
            WorkList.value = "";
            WorkList.JobMeasureMaterialID = "";
          }
          measuresDataArr.push(WorkList);
          measuresDataArrValue.push(WorkMeasures);
        }

        for (var j = 0; j < materialsDataList.length; j++) {
          var WorkListMet = {};
          var WorkMaterial = {};
          WorkListMet = materialsDataList[j];
          var WorkMet = materialsDataList[j].MaterialDetails;

          console.log("measuresDataList", measuresDataList);
          console.log("Materials", Materials);
          console.log("WorkMet", WorkMet);

          if (WorkMet.length > 0) {
            for (var k = 0; k < WorkMet.length; k++) {
              // Find the material in the Materials array that matches the WorkMeasureMaterialID
              const matchingMaterial = Materials.find(
                (material) =>
                  material?.WorkMeasureMaterialID ===
                  WorkMet[k]?.WorkMeasureMaterialId
              );

              console.log("matchingMaterial", matchingMaterial);

              if (matchingMaterial) {
                // If a matching material is found, update the values accordingly
                WorkListMet.MaterialDetails[k].value = matchingMaterial.Value;
                WorkListMet.MaterialDetails[k].JobMeasureMaterialID =
                  matchingMaterial.JobMeasureMaterialID;
                WorkListMet.value = matchingMaterial.WorkMeasureMaterialID;

                WorkMaterial["WorkMeasureMaterialID" + j] =
                  matchingMaterial.WorkMeasureMaterialID;
                WorkMaterial["JobMeasureMaterialID" + j] =
                  matchingMaterial.JobMeasureMaterialID;
                WorkMaterial["value" + j] = matchingMaterial.Value;

                console.log("j", j);

                // Update state based on the index
                if (j === 0) {
                  this.setState({
                    materialsdatamainwone: matchingMaterial.Value,
                    materialsdatamainone: matchingMaterial.Value,
                  });
                } else if (j === 1) {
                  this.setState({
                    materialsdatamainwtwo: matchingMaterial.Value,
                  });
                } else if (j === 2) {
                  this.setState({
                    materialsdatamainwthree: matchingMaterial.Value,
                  });
                } else if (j === 3) {
                  this.setState({
                    materialsdatamainwfour: matchingMaterial.Value,
                  });
                } else if (j === 4) {
                  this.setState({
                    materialsdatamainwfive: matchingMaterial.Value,
                  });
                } else if (j === 5) {
                  this.setState({
                    materialsdatamainwsix: matchingMaterial.Value,
                  });
                }
              } else {
                // If no matching material is found, reset the values
                WorkListMet.MaterialDetails[k].value = "";
                WorkListMet.MaterialDetails[k].JobMeasureMaterialID = "";
              }
            }
          } else {
            for (var k = 0; k < WorkMet.length; k++) {
              // Find the material in the Materials array that matches the WorkMeasureMaterialID
              const matchingMaterial = Materials.find(
                (material) =>
                  material?.WorkMeasureMaterialID ===
                  WorkMet[k]?.WorkMeasureMaterialId
              );

              if (matchingMaterial) {
                // If a matching material is found, update the values accordingly
                WorkListMet.MaterialDetails[k].value = matchingMaterial.Value;
                WorkListMet.MaterialDetails[k].JobMeasureMaterialID =
                  matchingMaterial.JobMeasureMaterialID;

                WorkMaterial["WorkMeasureMaterialID" + k] =
                  matchingMaterial.WorkMeasureMaterialID;
                WorkMaterial["JobMeasureMaterialID" + k] =
                  matchingMaterial.JobMeasureMaterialID;
                WorkMaterial["value" + k] = matchingMaterial.Value;

                // Update state based on the index
                if (k === 0) {
                  this.setState({
                    materialsdatamainone: matchingMaterial.Value,
                  });
                } else if (k === 1) {
                  this.setState({
                    materialsdatamaintwo: matchingMaterial.Value,
                  });
                } else if (k === 2) {
                  this.setState({
                    materialsdatamainthree: matchingMaterial.Value,
                  });
                } else if (k === 3) {
                  this.setState({
                    materialsdatamainfour: matchingMaterial.Value,
                  });
                } else if (k === 4) {
                  this.setState({
                    materialsdatamainfive: matchingMaterial.Value,
                  });
                } else if (k === 5) {
                  this.setState({
                    materialsdatamainsix: matchingMaterial.Value,
                  });
                }
              } else {
                // If no matching material is found, reset the values
                WorkListMet.MaterialDetails[k].value = "";
                WorkListMet.MaterialDetails[k].JobMeasureMaterialID = "";
              }
            }
          }
          materialsDataArr.push(WorkListMet);
          materialsDataArrValue.push(WorkMaterial);
        }
      }

      var techDataMain = "";
      var techData = JSON.parse(localStorage.getItem("techData"));
      var techDataMainList = [];
      var techDataNameList = [];
      var TechniciansList = datarespjobs.Technicians;
      for (var l = 0; l < techData.length; l++) {
        var TechList = {};
        var TechName = "";
        TechList.name = techData[l].name;
        TechList.id = techData[l].id;
        TechList.IsTrainee = techData[l].IsTrainee;
        TechList.IsValid = techData[l].IsValid;
        const filteredJob = TechniciansList.filter((obj) => {
          return obj.TechnicianID === techData[l].id;
        });
        if (filteredJob.length > 0) {
          TechList.check = true;
          TechList.pcdata = filteredJob[0].IncentivePC;
          TechList.JobTechnicianID = filteredJob[0].JobTechnicianID;
          TechName = techData[l].name + "-" + filteredJob[0].IncentivePC;
        } else {
          TechList.check = false;
          TechList.pcdata = "";
          TechList.JobTechnicianID = 0;
        }
        techDataMainList.push(TechList);
        if (TechName !== "") {
          techDataNameList.push(TechName);
        }
      }
      techDataMain = techDataMainList;
      let time = datarespjobs.JobDuration;
      var Hours = Math.floor(time / 60);
      var minutes = time % 60;
      var Duration = Hours + ":" + minutes;
      this.setState({
        show: true,
        customer: customer,
        JobType: JobType,
        techDataMain: techDataMain,
        TechnicianName: techDataNameList,
        customerJob: customerJob,
        customerDate: customerDate,
        measuresData: measuresDataArr,
        materialsData: materialsDataArr,
        measures: measuresDataArrValue,
        materials: materialsDataArrValue,
        JobID: datarespjobs.JobID,
        SiteID: datarespjobs.SiteID,
        CustomerID: datarespjobs.CustomerID,
        JobDuration: Duration,
        IncludeMtrl: datarespjobs.IncludeMtrl,
        OnlyCasuals: datarespjobs.OnlyCasuals,
        Factory: datarespjobs.IsFactory,
        UG: datarespjobs.UG,
        JobTypeID: datarespjobs.JobTypeID,
        ModifiedDate: datarespjobs.ModifiedDate,
        StartDateTime: new Date(datarespjobs.StartDateTime),
        EndDateTime: new Date(datarespjobs.EndDateTime),
        startDate: new Date(datarespjobs.StartDateTime),
        endDate: new Date(datarespjobs.EndDateTime),
        Department: datarespjobs.Department,
        Technicians: datarespjobs.Technicians,
        ConveyorReference: datarespjobs.ConveyorReference,
        NumberOfCasuals: datarespjobs.NumberOfCasuals,
        Stage: datarespjobs.Stage,
        Status: datarespjobs.Status,
      });
    };

    if (this.state.Permission === "VALIDATE_JOB") {
      if (this.state.statusId === "10" || this.state.statusId === "30") {
        fetchjobedit();
      }
    } else if (this.state.Permission === "AUTHORIZE_JOB") {
      if (this.state.statusId === "60" || this.state.statusId === "80") {
        var currnetMonthData = this.state.currnetmonthdata;
        var currnetMonth = "";
        if (currnetMonthData === "") {
          currnetMonth = new Date();
        } else {
          currnetMonth = currnetMonthData;
        }
        var StatusValue = ["60", "80"];
        // var dateVali = false;
        // var selectedMonthData = Moment(currnetMonth).format('MM');
        // var currentMonthData = Moment(new Date()).format('MM');
        // var checkDate = Moment(currentMonthData).isBefore(selectedMonthData);
        // dateVali =checkDate;
        if (
          this.state.submitbtn === true &&
          StatusValue.some((element) => element === this.state.statusId) ===
            true
        ) {
          fetchjobedit();
        }
      }
    }
  };

  handleInputFetch = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var submitbtn = false;
    var loadingData = "No data found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });

    var today = this.state.currnetmonthdata;
    var dateFormat = Moment(today).format("YYYY-MM-DD");
    const siteID = this.state.siteId;
    const status = this.state.statusId;
    var sendData = {
      date: dateFormat,
      site_id: siteID,
      status: status,
      user_id: userId,
    };
    const fetchjobdetails = async () => {
      const responsejobs = await getBackJobs(sendData);
      const datarespjobs = await responsejobs;
      var JobIDArr = [];
      if (datarespjobs.length > 0) {
        const filtered = datarespjobs.filter((obj) => {
          return obj.ShowBulkAuthButton === true;
        });
        if (filtered.length > 0) {
          submitbtn = filtered[0].ShowBulkAuthButton;
        } else {
          submitbtn = false;
        }
      } else {
        loadingData = "No data found";
      }
      var sendDataOther = {
        userid: userId,
      };
      const responseDates = await getBackJobDates(sendDataOther);
      const datarespDates = await responseDates;

      var dateArr = [];
      for (var i = 0; i < datarespDates.length; i++) {
        var dateData = new Date(datarespDates[i].CalendarDate);
        dateArr.push(dateData);
      }
      for (var i = 0; i < datarespjobs.length; i++) {
        if (datarespjobs[i].Changed === "N") {
          var JobID = datarespjobs[i].JobID;
          JobIDArr.push(JobID);
        }
      }
      this.setState({
        jobdetails: datarespjobs,
        expanded: JobIDArr,
        show: false,
        submitbtn: submitbtn,
        dateArr: dateArr,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchjobdetails();
  };

  handleInputChange = (event) => {
    this.setState({
      currnetmonthdata: event,
      jobdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handleNumberCasChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    this.setState({ NumberOfCasuals: value });
  };

  handleDataChange = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value.toUpperCase(),
    });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleDataChangeTech = (i) => (event) => {
    this.setState((state, props) => {
      state.techDataMain[i].check = event.target.checked;
      return {
        techDataMain: state.techDataMain,
      };
    });
  };

  handleDataChangeTechOther = (i) => (event) => {
    event.preventDefault();
    this.setState((state, props) => {
      state.techDataMain[i].pcdata = event.target.value;
      return {
        techDataMain: state.techDataMain,
      };
    });
  };

  handleNextChange = (event) => {
    var date = new Date(this.state.currnetmonthdata);
    var dateCurrent = date.setDate(date.getDate() - 1);
    this.setState({
      currnetmonthdata: dateCurrent,
      jobdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handlePreChange = (event) => {
    var date = new Date(this.state.currnetmonthdata);
    var dateCurrent = date.setDate(date.getDate() + 1);
    this.setState({
      currnetmonthdata: dateCurrent,
      jobdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handleChange = (selectedDate) => {
    this.setState({
      StartDateTime: selectedDate,
    });
  };

  handleChangeEnd = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    var errorClass = "";
    if (
      this.state.StartDateTime !== "" &&
      this.state.StartDateTime !== null &&
      this.state.StartDateTime !== undefined
    ) {
      var Difference_In_Time =
        selectedDate.getTime() - this.state.StartDateTime.getTime();
      var Difference_In_Minutes = Difference_In_Time / (1000 * 60);
      var num = parseInt(Difference_In_Minutes);
      var hoursdata = num / 60;
      var hours = parseInt(hoursdata);
      var minutesdata = (hoursdata - hours) * 60;
      var minutes = parseInt(minutesdata);
      const durationTime = hours + ":" + minutes;
      if (hours > 0 || minutes > 0) {
        errorClass = "duration_data";
      } else {
        errorClass = "errorClass duration_data";
      }
      this.setState({
        EndDateTime: selectedDate,
        JobDuration: durationTime,
        errorClass: errorClass,
      });
    } else {
      MySwal.fire("<p>Please select start date first<p>");
    }
  };

  change = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    materials[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: value,
      [threeData]: nameSplite[3],
    };

    this.setState({ materials });
  };

  changeMaterials = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[3] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      var threeData = "JobMeasureMaterialID" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
        [threeData]: nameSplite[3],
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[1];
      var valuedata = materials[nameSplite[1]][seconData];
      var threeData = "JobMeasureMaterialID" + nameSplite[1];
      var threeDataMain = materials[nameSplite[1]][threeData];
      materials[nameSplite[1]] = {
        [nameData]: value,
        [seconData]: valuedata,
        [threeData]: threeDataMain,
      };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainwone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamainwtwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainwthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainwfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainwfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainwsix: value });
      }
    }
    this.setState({ materials });
  };

  changeMaterialsDec = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,1})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[3] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      var threeData = "JobMeasureMaterialID" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
        [threeData]: nameSplite[3],
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[1];
      var valuedata = materials[nameSplite[1]][seconData];
      var threeData = "JobMeasureMaterialID" + nameSplite[1];
      var threeDataMain = materials[nameSplite[1]][threeData];
      materials[nameSplite[1]] = {
        [nameData]: value,
        [seconData]: valuedata,
        [threeData]: threeDataMain,
      };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainwone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamainwtwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainwthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainwfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainwfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainwsix: value });
      }
    }
    this.setState({ materials });
  };

  changeMeasuresDec = (e) => {
    e.preventDefault();
    let measures = this.state.measures;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,1})?)/g.exec(val);
    const value = match[1] + match[2];
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    measures[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: value,
      [threeData]: nameSplite[3],
    };
    if (nameSplite[2] === "0") {
      this.setState({ measuresdatamainone: value });
    } else if (nameSplite[2] === "1") {
      this.setState({ measuresdatamaintwo: value });
    } else if (nameSplite[2] === "2") {
      this.setState({ measuresdatamainthree: value });
    } else if (nameSplite[2] === "3") {
      this.setState({ measuresdatamainfour: value });
    } else if (nameSplite[2] === "4") {
      this.setState({ measuresdatamainfive: value });
    } else if (nameSplite[2] === "5") {
      this.setState({ measuresdatamainsix: value });
    }

    this.setState({ measures });
  };

  changeMeasures = (e) => {
    e.preventDefault();
    let measures = this.state.measures;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    measures[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: value,
      [threeData]: nameSplite[3],
    };
    if (nameSplite[2] === "0") {
      this.setState({ measuresdatamainone: value });
    } else if (nameSplite[2] === "1") {
      this.setState({ measuresdatamaintwo: value });
    } else if (nameSplite[2] === "2") {
      this.setState({ measuresdatamainthree: value });
    } else if (nameSplite[2] === "3") {
      this.setState({ measuresdatamainfour: value });
    } else if (nameSplite[2] === "4") {
      this.setState({ measuresdatamainfive: value });
    } else if (nameSplite[2] === "5") {
      this.setState({ measuresdatamainsix: value });
    }

    this.setState({ measures });
  };

  handleMaterialChange = (event) => {
    event.preventDefault();
    let materials = this.state.materials;
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    var nameData = "WorkMeasureMaterialID" + nameSplite[1];
    // var seconData = 'value'+nameSplite[2];
    // var threeData = 'JobMeasureMaterialID'+nameSplite[2];

    // materials[nameSplite[2]] = {[nameData]:nameSplite[1],[seconData]:event.target.value,[threeData]:nameSplite[3]};

    // var nameData = nameSplite[0]+nameSplite[1];
    var seconData = "value" + nameSplite[1];
    var valuedata = materials[nameSplite[1]][seconData];
    var threeData = "JobMeasureMaterialID" + nameSplite[1];
    var threeDataMain = materials[nameSplite[1]][threeData];
    materials[nameSplite[1]] = {
      [seconData]: valuedata,
      [nameData]: event.target.value,
      [threeData]: threeDataMain,
    };

    this.setState({ materialsdatamainseven: event.target.value });
    this.setState({
      materials,
    });
  };

  handleMaterialChangeOther = (event) => {
    event.preventDefault();
    let materials = this.state.materials;
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    materials[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: event.target.value,
      [threeData]: nameSplite[3],
    };
    if (nameSplite[2] === "0") {
      this.setState({ materialsdatamainone: event.target.value });
    } else if (nameSplite[2] === "1") {
      this.setState({ materialsdatamaintwo: event.target.value });
    } else if (nameSplite[2] === "2") {
      this.setState({ materialsdatamainthree: event.target.value });
    } else if (nameSplite[2] === "3") {
      this.setState({ materialsdatamainfour: event.target.value });
    } else if (nameSplite[2] === "4") {
      this.setState({ materialsdatamainfive: event.target.value });
    } else if (nameSplite[2] === "5") {
      this.setState({ materialsdatamainsix: event.target.value });
    }
    // this.setState({materialsdatamainseven :event.target.value});

    this.setState({
      materials,
    });
  };

  handleMeasuresChange = (event) => {
    event.preventDefault();
    let measures = this.state.measures;
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    measures[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: event.target.value,
      [threeData]: nameSplite[3],
    };

    this.setState({
      measures,
    });
  };

  handleMeasuresChangeOther = (event) => {
    event.preventDefault();
    let measures = this.state.measures;
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    measures[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: event.target.value,
      [threeData]: nameSplite[3],
    };
    if (nameSplite[2] === "0") {
      this.setState({ measuresdatamainone: event.target.value });
    } else if (nameSplite[2] === "1") {
      this.setState({ measuresdatamaintwo: event.target.value });
    } else if (nameSplite[2] === "2") {
      this.setState({ measuresdatamainthree: event.target.value });
    } else if (nameSplite[2] === "3") {
      this.setState({ measuresdatamainfour: event.target.value });
    } else if (nameSplite[2] === "4") {
      this.setState({ measuresdatamainfive: event.target.value });
    } else if (nameSplite[2] === "5") {
      this.setState({ measuresdatamainsix: event.target.value });
    }
    this.setState({
      measures,
    });
  };

  handleNumberChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    this.setState({ [event.target.name]: value });
  };

  handleNumberMaterialChange = (event) => {
    event.preventDefault();
    let materials = this.state.materials;
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      var threeData = "JobMeasureMaterialID" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
        [threeData]: nameSplite[3],
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[2];
      var threeData = "JobMeasureMaterialID" + nameSplite[2];
      materials[nameSplite[1]] = {
        [nameData]: value,
        [seconData]: this.state.WorkMeasureMaterialID,
        [threeData]: nameSplite[3],
      };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    }
    this.setState({ materials });
  };

  handleNumberMeasuresChange = (event) => {
    event.preventDefault();
    let measures = this.state.measures;
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    var nameData = "WorkMeasureMaterialID" + nameSplite[2];
    var seconData = "value" + nameSplite[2];
    var threeData = "JobMeasureMaterialID" + nameSplite[2];
    measures[nameSplite[2]] = {
      [nameData]: nameSplite[1],
      [seconData]: value,
      [threeData]: nameSplite[3],
    };
    if (nameSplite[2] === "0") {
      this.setState({ measuresdatamainone: value });
    } else if (nameSplite[2] === "1") {
      this.setState({ measuresdatamaintwo: value });
    } else if (nameSplite[2] === "2") {
      this.setState({ measuresdatamainthree: value });
    } else if (nameSplite[2] === "3") {
      this.setState({ measuresdatamainfour: value });
    } else if (nameSplite[2] === "4") {
      this.setState({ measuresdatamainfive: value });
    } else if (nameSplite[2] === "5") {
      this.setState({ measuresdatamainsix: value });
    }

    this.setState({ measures });
  };

  handleNumberCasChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    this.setState({ NumberOfCasuals: value });
  };

  handleFormValidation = (event) => {
    let isError = this.state.isError;
    var validationcon = [];
    if (event.StartDateTime === "") {
      isError["StartDateTime"] = "Please enter start date";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["StartDateTime"] = "";
      this.setState({ isError });
    }
    if (event.endDate === "") {
      isError["EndDateTime"] = "Please enter end date";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      if (event.EndDateTime > new Date()) {
        isError["EndDateTime"] = "Job end time must be less than current time";
        this.timeInput.current.setFocus();
        this.setState({ isError });
        validationcon.push(1);
      } else {
        isError["EndDateTime"] = "";
        this.setState({ isError });
      }
    }
    if (event.StartDateTime.getTime() >= event.EndDateTime.getTime()) {
      isError["duration"] = "Job end time must be later than job start time";
      this.setState({ isError });
      this.timeInput.current.setFocus();
      validationcon.push(1);
    } else {
      isError["duration"] = "";
      this.setState({ isError });
    }

    if (event.Department === "") {
      isError["Department"] = "Please enter department";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["Department"] = "";
      this.setState({ isError });
    }
    if (event.ConveyorReference === "") {
      isError["ConveyorReference"] = "Please enter conveyor number";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["ConveyorReference"] = "";
      this.setState({ isError });
    }

    if (event.Remarks === "" && event.submitvalue !== "10") {
      isError["Remarks"] = "Please enter Remarks";
      this.setState({ isError });
      this.remarkInput.current.focus();
      validationcon.push(1);
    } else {
      isError["Remarks"] = "";
      this.setState({ isError });
    }

    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    if (event.techDataMain.length <= 0) {
      isError["TechnicianName"] = "Please select technicians";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      var Technicians = this.state.techDataMain;
      let sum = Technicians.reduce(function (prev, current) {
        return prev + +current.pcdata;
      }, 0);

      for (var i = 0; i < Technicians.length; i++) {
        if (Technicians[i].IsTrainee === false) {
          if (Technicians[i].check === true) {
            // Check for Tenant "Thisco"
            if (selectedTenantData.Tenant !== "Thisco") {
              if (
                Technicians[i].pcdata !== "" &&
                Technicians[i].pcdata !== undefined &&
                Technicians[i].pcdata !== null
              ) {
                if (sum === 100) {
                  if (validationcon.length === 0) {
                    isError["TechnicianName"] = "";
                    this.setState({ isError });
                  }
                } else {
                  if (event.OnlyCasuals === false) {
                    isError["TechnicianName"] =
                      "Percentage split should be 100";
                    this.setState({ isError });
                    this.textInput.current.focus();
                    validationcon.push(1);
                  }
                }
              } else {
                if (event.OnlyCasuals === false) {
                  isError["TechnicianName"] = "Please enter percentage";
                  this.setState({ isError });
                  this.textInput.current.focus();
                  validationcon.push(1);
                }
              }
            }
          } else {
            let selectedProductsArray = this.state.techDataMain.filter(
              (product, i) => {
                return product.check;
              }
            );
            if (selectedProductsArray.length === 0) {
              isError["TechnicianName"] = "Please select technicians";
              this.setState({ isError });
              validationcon.push(1);
            }
          }
        }
      }
    }

    if (event.NumberOfCasuals === "") {
      isError["NumberOfCasuals"] = "Please enter number of casuals";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["NumberOfCasuals"] = "";
      this.setState({ isError });
    }
    return validationcon;
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    var resp = this.handleFormValidation(this.state);
    var submitvalue = this.state.submitvalue;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var url = "";
    this.setState({
      jobdetails: [],
    });

    if (resp.length <= 0) {
      var Technicians = this.state.techDataMain;
      var TechniciansData = [];
      for (var i = 0; i < Technicians.length; i++) {
        var TechniciansDataMain = {};
        if (Technicians[i].check === true) {
          TechniciansDataMain["JobTechnicianID"] =
            Technicians[i].JobTechnicianID;
          TechniciansDataMain["TechnicianID"] = parseInt(Technicians[i].id);
          TechniciansDataMain["IncentivePC"] =
            Technicians[i].pcdata !== "" && Technicians[i].pcdata !== null
              ? parseInt(Technicians[i].pcdata)
              : 0;
          TechniciansData.push(TechniciansDataMain);
        }
      }

      var measures = this.state.measures;
      var measuresData = [];
      for (var k = 0; k < measures.length; k++) {
        var measuresDataMain = {};
        var workname = "WorkMeasureMaterialID" + k;
        var valuename = "value" + k;
        var jobname = "JobMeasureMaterialID" + k;
        measuresDataMain["JobMeasureMaterialID"] = measures[k][jobname];
        measuresDataMain["WorkMeasureMaterialID"] = measures[k][workname];
        measuresDataMain["Value"] = measures[k][valuename];
        measuresData.push(measuresDataMain);
      }

      var materials = this.state.materials;
      var materialsData = [];
      if (materials.every((obj) => Object.keys(obj).length === 0)) {
        var materialsData = [];
      } else {
        for (var j = 0; j < materials.length; j++) {
          if (Object.keys(materials[j]).length === 0) {
            continue;
          }

          var materialsDataMain = {};
          var workname = "WorkMeasureMaterialID" + j;
          let valuename = "value" + j;
          var jobname = "JobMeasureMaterialID" + j;
          materialsDataMain["JobMeasureMaterialID"] = materials[j][jobname];
          materialsDataMain["WorkMeasureMaterialID"] = parseInt(
            materials[j][workname]
          );
          materialsDataMain["Value"] = materials[j][valuename];
          materialsData.push(materialsDataMain);
        }
      }

      if (
        this.state.statusId === "30" ||
        this.state.statusId === "60" ||
        this.state.statusId === "80"
      ) {
        if (submitvalue === "10") {
          this.setState({
            show: false,
          });
        }
      }

      if (submitvalue === "90") {
        url = "approve/";
      } else if (submitvalue === "60") {
        url = "validate/";
      } else if (submitvalue === "70") {
        url = "reject/";
      } else if (submitvalue === "80") {
        url = "hold/";
      }

      const selectedTenant = localStorage.getItem("selected_tenant");
      const selectedTenantData = JSON.parse(selectedTenant);

      var submitData = {
        JobID: this.state.JobID,
        JobTypeID: this.state.JobTypeID,
        SiteID: this.state.SiteID,
        CustomerID: this.state.CustomerID,
        StartDateTime: Moment(this.state.StartDateTime).format(),
        EndDateTime: Moment(this.state.EndDateTime).format(),
        JobDuration: 0,
        IncludeMtrl: this.state.IncludeMtrl,
        OnlyCasuals: this.state.OnlyCasuals,
        IsFactory:
          selectedTenantData.Tenant === "Thisco" ? this.state.Factory : null,
        UG: this.state.UG,
        Department: this.state.Department,
        ConveyorReference: this.state.ConveyorReference,
        NumberOfCasuals: this.state.NumberOfCasuals,
        Status: this.state.Status,
        ModifiedBy: userId,
        ModifiedDate: this.state.ModifiedDate,
        Remarks: this.state.Remarks,
        Measures: measuresData,
        Materials: materialsData,
        Technicians: TechniciansData,
      };

      const fetchjobsubmit = async () => {
        const responceData = await getUpdateJob(submitData, url);

        if (responceData === 200) {
          this.setState({
            show: false,
            Remarks: "",
            materialsdatamainone: "",
            isError: {
              StartDateTime: "",
              EndDateTime: "",
              duration: "",
              Department: "",
              ConveyorReference: "",
              NumberOfCasuals: "",
              TechnicianName: "",
            },
          });
          var today = this.state.currnetmonthdata;
          var dateFormat = Moment(today).format("YYYY-MM-DD");
          const siteID = this.state.siteId;
          const status = this.state.statusId;
          var sendData = {
            date: dateFormat,
            site_id: siteID,
            status: status,
            user_id: userId,
          };
          var submitDataClick = {
            JobID: this.state.JobID,
            JobTypeID: this.state.JobTypeID,
            JobType: this.state.JobType,
            CustomerName: this.state.customer,
          };

          if (submitvalue === "10") {
            // this.handleBtnClick(submitDataClick);
            this.setState({
              show: false,
            });
          }
          const fetchjobdetails = async () => {
            const responsejobs = await getBackJobs(sendData);
            const datarespjobs = await responsejobs;
            var JobIDArr = [];
            for (var i = 0; i < datarespjobs.length; i++) {
              if (datarespjobs[i].Changed === "N") {
                var JobID = datarespjobs[i].JobID;
                JobIDArr.push(JobID);
              }
            }
            var sendLogData = {
              JobID: this.state.JobID,
            };
            //  this.handleOnExpand(sendLogData);
            this.setState({
              expanded: JobIDArr,
              jobdetails: datarespjobs,
              //  show: show,
            });
          };
          fetchjobdetails();
        }
      };

      if (
        submitvalue === "70" ||
        submitvalue === "90" ||
        submitvalue === "60"
      ) {
        var msg = "You want to reject !";
        if (submitvalue === "90") {
          var msg = "You want to approve !";
        } else if (submitvalue === "60") {
          var msg = "You want to validate !";
        }
        Swal.fire({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            fetchjobsubmit();
          }
        });
      } else {
        fetchjobsubmit();
      }

      // if(responceData){
      //   this.handleInputFetch
      // }
    }
  };

  handleAthBtn = (event) => {
    var siteId = this.state.siteId;
    var currnetmonthdata = this.state.currnetmonthdata;
    var statusId = this.state.statusId;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var msg = "You want to Authorize !";
    const fetchjobsubmit = async () => {
      var sendData = {
        auth_date: Moment(currnetmonthdata).format("YYYY-MM-DD"),
        site_id: siteId,
        modified_by: userId,
        current_status: statusId,
      };
      const responsejobs = await getBackJobsAuth(sendData);
      const datarespjobs = await responsejobs;
      this.handleInputFetch();
    };
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        fetchjobsubmit();
      }
    });
  };

  handleClose = (event) => {
    this.setState({
      show: false,
      materialsdatamainwone: "",
      materialsdatamainwtwo: "",
      materialsdatamainwthree: "",
      materialsdatamainwfour: "",
      materialsdatamainwfive: "",
      materialsdatamainwsix: "",
      materialsdatamainone: "",
      materialsdatamaintwo: "",
      materialsdatamainthree: "",
      materialsdatamainfour: "",
      materialsdatamainfive: "",
      materialsdatamainsix: "",
    });
  };

  handleChangeCheck = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handleShow = (event) => {
    this.setState({ show: true, customer: event.target.value });
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      jobdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handleDropdownSite = (key, event) => {
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      jobdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handleOnExpand = (row, isExpand, rowIndex, e) => {
    const fetchjobLogs = async () => {
      var sendData = {
        jobId: row.JobID,
      };
      const responsejobsLogs = await getJobLog(sendData);
      const datarespjobsLogs = await responsejobsLogs;
      this.setState((state, props) => {
        state.jobLogs[row.JobID] = datarespjobsLogs;
        return {
          jobLogs: state.jobLogs,
        };
      });
    };
    fetchjobLogs();
  };

  render() {
    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);

    var currnetMonthData = this.state.currnetmonthdata;
    var currnetMonth = "";
    if (currnetMonthData === "") {
      currnetMonth = new Date();
    } else {
      currnetMonth = currnetMonthData;
    }
    var StatusValue = ["60", "80"];
    var dateVali = false;
    var selectedMonthData = Moment(currnetMonth).format("MM");
    var currentMonthData = Moment(new Date()).format("MM");
    var checkDate = Moment(currentMonthData).isBefore(selectedMonthData);
    dateVali = checkDate;

    const editpen = require("../../../assets/images/editpen.png");
    const columns = [
      {
        dataField: "JobID",
        text: "Job#",
        classes: (cell, row, rowIndex, colIndex) => {
          var currnetMonthData = this.state.currnetmonthdata;
          var currnetMonth = "";
          if (currnetMonthData === "") {
            currnetMonth = new Date();
          } else {
            currnetMonth = currnetMonthData;
          }
          var StatusValue = ["60", "80"];
          var dateVali = false;
          var selectedMonthData = Moment(currnetMonth).format("MM");
          var currentMonthData = Moment(new Date()).format("MM");
          var checkDate = Moment(currentMonthData).isBefore(selectedMonthData);
          dateVali = checkDate;

          if (this.state.Permission === "VALIDATE_JOB") {
            if (this.state.statusId === "10" || this.state.statusId === "30") {
              return "cursor jobidtd";
            }
          } else if (this.state.Permission === "AUTHORIZE_JOB") {
            if (this.state.statusId === "60" || this.state.statusId === "80") {
              if (
                this.state.submitbtn === true &&
                StatusValue.some(
                  (element) => element === this.state.statusId
                ) === true
              ) {
                return "cursor jobidtd";
              } else {
                return "jobidtd";
              }
            }
          } else {
            return "jobidtd";
          }
        },
        sort: true,
        headerClasses: "jobidtd",
        filter: textFilter({ className: "filter_class" }),
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.handleBtnClick(row);
          },
        },
      },
      {
        dataField: "CustomerName",
        text: "Customer",
        sort: true,
        headerClasses: "customertd",
        classes: "customertd",
        filter: textFilter({ className: "filter_class" }),
      },
      {
        dataField: "JobType",
        text: "Work",
        sort: true,
        headerClasses: "jobtypetd",
        classes: "jobtypetd",
        filter: textFilter({ className: "filter_class" }),
      },
      {
        dataField: "TechNames",
        text: "Technicians",
        headerClasses: "technametd",
        classes: "technametd",
      },
      {
        dataField: "Remarks",
        text: "Remarks",
        headerClasses: "remarktd",
        classes: "remarktd",
      },
      {
        dataField: "Measures",
        text: "Measurements",
        headerClasses: "measurestd",
        classes: "measurestd",
      },
      {
        dataField: "Materials",
        text: "Materials",
        headerClasses: "materialstd",
        classes: "materialstd",
      },
      {
        dataField: "Department",
        text: "Dept",
        sort: true,
        headerClasses: "departmenttd",
        classes: "departmenttd",
        filter: textFilter({ className: "filter_class" }),
      },
      {
        dataField: "ConveyorReference",
        text: "Conv Ref",
        sort: true,
        headerClasses: "conveyorreferencetd",
        classes: "conveyorreferencetd",
        filter: textFilter({ className: "filter_class" }),
      },
      {
        dataField: "JobDates",
        text: "Date & Time",
        headerClasses: "jobdatetd",
        classes: "jobdatetd",
      },
      {
        dataField: "NumberOfCasuals",
        headerClasses: "numberofcasualtd",
        text: "Casuals",
        classes: "numberofcasualtd",
      },
    ];
    var products = this.state.jobdetails;
    const expandRow = {
      className: "expanding-foo",
      showExpandColumn: true,
      expandByColumnOnly: true,
      renderer: (row) => (
        <div className="jobLogData">
          {this.state.jobLogs[row.JobID] !== "" &&
          this.state.jobLogs[row.JobID] !== null &&
          this.state.jobLogs[row.JobID] !== undefined ? (
            this.state.jobLogs[row.JobID].ChangeInfos.map(
              (ChangeInfos, indexId) =>
                indexId > 8 ? (
                  <span key={indexId} className="jobLogLink">
                    {indexId + 1 + ")"}&nbsp;&nbsp;{ChangeInfos.ChangesDone}
                  </span>
                ) : (
                  <span key={indexId} className="jobLogLink">
                    {indexId + 1 + ")"}&nbsp;&nbsp;&nbsp;&nbsp;
                    {ChangeInfos.ChangesDone}
                  </span>
                )
            )
          ) : (
            <p className="loadingLog">
              <Spinner animation="grow" variant="primary" />
            </p>
          )}
          {/* <p>expandRow.renderer callback will pass the origin row object to you</p> */}
        </div>
      ),

      nonExpandable: this.state.expanded,
      // expandByColumnOnly: true,
      onExpand: this.handleOnExpand,
    };
    var listSiteId = "";
    var TechnicianNameData = this.state.techDataMain;
    var TechnicianNameArr = [];

    if (TechnicianNameData !== "") {
      for (var i = 0; i < TechnicianNameData.length; i++) {
        if (TechnicianNameData[i].check === true) {
          var mainTech =
            TechnicianNameData[i].name +
            (selectedTenantData.Tenant !== "Thisco"
              ? ` (${TechnicianNameData[i].pcdata}%)`
              : "");
          if (TechnicianNameData[i].IsValid) {
            TechnicianNameArr.push(
              <span key={i} className="validTech">
                {mainTech}
              </span>
            );
          } else {
            TechnicianNameArr.push(
              <span key={i} className="invalidTech">
                {mainTech}
              </span>
            );
          }
        }
      }
    }
    if (this.state.listSiteId !== "") {
      var listSiteId = this.state.listSiteId;
    }

    var listStatus = [
      { key: "10", value: "Created" },
      { key: "20", value: "Branch Rejected" },
      { key: "30", value: "Branch Hold" },
      { key: "60", value: "Validated" },
      { key: "70", value: "HO Rejected" },
      { key: "80", value: "HO Hold" },
      { key: "90", value: "HO Approved" },
      { key: "100", value: "Processed" },
    ];

    if (this.state.Permission === "VALIDATE_JOB") {
      listStatus = [
        { key: "10", value: "Created" },
        { key: "30", value: "Branch Hold" },
        { key: "20", value: "Branch Rejected" },
        { key: "60", value: "Validated" },
      ];
    } else if (this.state.Permission === "AUTHORIZE_JOB") {
      listStatus = [
        { key: "60", value: "Validated" },
        { key: "80", value: "HO Hold" },
        { key: "70", value: "HO Rejected" },
        { key: "90", value: "HO Authorize" },
      ];
    }

    const highlightWithRanges = [
      {
        "react-datepicker__day--highlighted-custom-1": this.state.dateArr,
      },
    ];

    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter">
            <div className="viewcalander">
              <span
                className="cursor marginClass"
                onClick={this.handleNextChange}
              >
                <AiOutlineDoubleLeft />
              </span>
              <DatePicker
                selected={currnetMonth}
                onChange={(date) => this.handleInputChange(date)}
                dateFormat="dd-MMM-yyyy"
                highlightDates={highlightWithRanges}
                className="input-date-data outLine font_size"
              />
              <span
                className="cursor marginClass"
                onClick={this.handlePreChange}
              >
                <AiOutlineDoubleRight />
              </span>
            </div>

            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="info"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatus.map((item, index) => {
                    return (
                      <Dropdown.Item
                        className="font_size"
                        key={index}
                        eventKey={item.key}
                      >
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
            {this.state.Permission === "AUTHORIZE_JOB" &&
            this.state.submitbtn === true &&
            StatusValue.some((element) => element === this.state.statusId) ===
              true ? (
              <div className="submiteditbtnAuth">
                <button
                  type="button"
                  className="btnval btn btn-success font_size"
                  onClick={this.handleAthBtn}
                >
                  Authorize All
                </button>
              </div>
            ) : (
              ""
            )}

            {/* <button type="button" className="btnrej btn btn-danger font_size">
                Reject
              </button>
              <button type="button" className="btnhol btn btn-dark font_size">
                Hold
              </button> */}
          </div>
        </div>
        {/* <div className="headerfilter">
          <table className='tableVali'>
            <thead>
              <tr>
                <th>
                  Validation Stage
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>To be validated</td>
                <td>Validated</td>
                <td>Rejected</td>
              </tr>
            </tbody>
          </table>
        </div> */}

        <div className="table-container">
          <BootstrapTable
            classes="tabledata"
            keyField="JobID"
            id="tabledata"
            data={products}
            columns={columns}
            expandRow={expandRow}
            filter={filterFactory({ className: "custom_filter_class" })}
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          />
        </div>
        <Offcanvas
          show={this.state.show}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              <span className="title_contant">{this.state.customerJob}</span> -{" "}
              {this.state.customer}
              <p>{this.state.customerDate}</p>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {this.state.customer === "" ? (
              <span className="loaderClass">
                <Spinner animation="grow" variant="primary" />
                <Spinner animation="grow" variant="secondary" />
                <Spinner animation="grow" variant="success" />
                <Spinner animation="grow" variant="danger" />
                <Spinner animation="grow" variant="warning" />
                <Spinner animation="grow" variant="info" />
                <Spinner animation="grow" variant="dark" />
              </span>
            ) : (
              ""
            )}
            <span>
              {this.state.editjob !== "" ? (
                <div className="container">
                  <div className="rowUser justify-content-center rowUserData">
                    <div className="col-md-12">
                      <form
                        method="POST"
                        className="formJob"
                        onSubmit={this.handleFormSubmit}
                      >
                        <div className="rowUser rowUserData">
                          <div className="col-md-4 form-group input-user">
                            <DatePicker
                              onChange={this.handleChange}
                              selected={this.state.StartDateTime}
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={15}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              required
                              placeholderText="Time *"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-4 form-group input-user otherpic">
                            <DatePicker
                              timeIntervals={15}
                              onChange={this.handleChangeEnd}
                              selected={this.state.EndDateTime}
                              showTimeSelect
                              ref={this.timeInput}
                              dateFormat="dd-MMM-yyyy hh:mm a"
                              minDate={this.state.startDate}
                              maxDate={this.state.lasttdate}
                              required
                              placeholderText="Date and Time *"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <span className={this.state.errorClass}>
                              {this.state.JobDuration}
                            </span>
                          </div>
                          {this.state.isError.duration !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.duration}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="rowUser rowUserData">
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingInputGrid"
                              className="lableWidth"
                              label="Department *"
                            >
                              <Form.Control
                                type="text"
                                maxLength="50"
                                required
                                name="Department"
                                onChange={this.handleDataChange}
                                placeholder="Department (max 50 charcter) "
                                className="edit_job_edit form__field"
                                value={this.state.Department}
                              />
                              {this.state.isError.Department !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.Department}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelectGrid"
                              className="lableWidth"
                              label="Conveyor Number *"
                            >
                              <Form.Control
                                type="text"
                                maxLength="50"
                                required
                                name="ConveyorReference"
                                onChange={this.handleDataChange}
                                placeholder="Conveyor Number"
                                className="edit_job_edit form__field"
                                value={this.state.ConveyorReference}
                              />
                              {this.state.isError.ConveyorReference !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.ConveyorReference}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                        </div>
                        {this.state.measures.length > 0 ? (
                          <h1 className="headingClass">Measures</h1>
                        ) : (
                          ""
                        )}
                        {/* <span className='title_data'>Measures</span> */}
                        <div className="rowUser rowUserData">
                          {this.state.measuresData !== ""
                            ? this.state.measuresData.map(
                                (measures, indexmain) =>
                                  measures.DataType === "Char" ? (
                                    <div className="col-md-4 form-group input-user">
                                      <FloatingLabel
                                        key={indexmain}
                                        className="lableWidth"
                                        label={
                                          measures.Required === 1
                                            ? measures.UoM !== ""
                                              ? measures.MeasureName +
                                                " (" +
                                                measures.UoM +
                                                ") *"
                                              : measures.MeasureName + " *"
                                            : measures.UoM !== ""
                                            ? measures.MeasureName +
                                              " (" +
                                              measures.UoM +
                                              ")"
                                            : measures.MeasureName
                                        }
                                      >
                                        <Form.Control
                                          className="edit_job_edit form__field"
                                          type="text"
                                          maxLength="100"
                                          required={
                                            measures.Required === 1
                                              ? true
                                              : false
                                          }
                                          name={
                                            "value" +
                                            "-" +
                                            measures.WorkMeasureMaterialId +
                                            "-" +
                                            indexmain +
                                            "-" +
                                            measures.JobMeasureMaterialID
                                          }
                                          onChange={
                                            this.handleMeasuresChangeOther
                                          }
                                          value={
                                            indexmain === 0
                                              ? this.state.measuresdatamainone
                                              : indexmain === 1
                                              ? this.state.measuresdatamaintwo
                                              : indexmain === 2
                                              ? this.state.measuresdatamainthree
                                              : indexmain === 3
                                              ? this.state.measuresdatamainfour
                                              : indexmain === 4
                                              ? this.state.measuresdatamainfive
                                              : indexmain === 5
                                              ? this.state.measuresdatamainsix
                                              : ""
                                          }
                                          placeholder={
                                            measures.MeasureName +
                                            " (" +
                                            measures.UoM +
                                            ")"
                                          }
                                        />
                                      </FloatingLabel>
                                    </div>
                                  ) : (
                                    <div className="col-md-4 form-group input-user">
                                      <FloatingLabel
                                        key={indexmain + 1}
                                        className="lableWidth"
                                        label={
                                          measures.Required === 1
                                            ? measures.UoM !== ""
                                              ? measures.MeasureName +
                                                " (" +
                                                measures.UoM +
                                                ") *"
                                              : measures.MeasureName + " *"
                                            : measures.UoM !== ""
                                            ? measures.MeasureName +
                                              " (" +
                                              measures.UoM +
                                              ")"
                                            : measures.MeasureName
                                        }
                                      >
                                        <Form.Control
                                          className="edit_job_edit form__field"
                                          type="number"
                                          required={
                                            measures.Required === 1
                                              ? true
                                              : false
                                          }
                                          name={
                                            "value" +
                                            "-" +
                                            measures.WorkMeasureMaterialId +
                                            "-" +
                                            indexmain +
                                            "-" +
                                            measures.JobMeasureMaterialID
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          onChange={
                                            measures.DataType === "Int"
                                              ? this.handleNumberMeasuresChange
                                              : measures.DataType === "Dec1"
                                              ? this.changeMeasuresDec
                                              : this.changeMeasures
                                          }
                                          step={
                                            measures.DataType === "Int"
                                              ? ""
                                              : "0.0000001"
                                          }
                                          value={
                                            indexmain === 0
                                              ? this.state.measuresdatamainone
                                              : indexmain === 1
                                              ? this.state.measuresdatamaintwo
                                              : indexmain === 2
                                              ? this.state.measuresdatamainthree
                                              : indexmain === 3
                                              ? this.state.measuresdatamainfour
                                              : indexmain === 4
                                              ? this.state.measuresdatamainfive
                                              : indexmain === 5
                                              ? this.state.measuresdatamainsix
                                              : ""
                                          }
                                          placeholder={
                                            measures.MeasureName +
                                            " (" +
                                            measures.UoM +
                                            ")"
                                          }
                                        />
                                      </FloatingLabel>
                                    </div>
                                  )
                              )
                            : ""}
                        </div>
                        {this.state.materials.length > 0 &&
                        this.state.showMaterial.length > 0 ? (
                          <h1 className="headingClass">Material</h1>
                        ) : (
                          ""
                        )}
                        {/* <span className='title_data'>Material</span> */}

                        {this.state.materialsData !== "" &&
                        this.state.showMaterial.length > 0
                          ? this.state.materialsData
                              // .filter(
                              //   (materials) =>
                              //     materials.value !== undefined &&
                              //     materials.value !== null
                              // ) // Filter out materials without a 'value' key
                              .map((materials, index) =>
                                materials.MaterialDetails.length > 1 ? (
                                  <div
                                    className="rowUser rowUserData mt-4"
                                    key={index}
                                    style={{
                                      display:
                                        materials.value !== undefined &&
                                        materials.value !== null
                                          ? "flex"
                                          : "none", // Conditionally hide the row if 'value' is undefined or null
                                    }}
                                  >
                                    <div className="col-md-6 form-group input-user">
                                      <FloatingLabel
                                        className=""
                                        label={
                                          materials.Required === 1 &&
                                          selectedTenantData.Tenant !== "Thisco"
                                            ? "Select Type of " +
                                              materials.MaterialType +
                                              " *"
                                            : "Select Type of " +
                                              materials.MaterialType
                                        }
                                        key={index}
                                      >
                                        <Form.Select
                                          aria-label={materials.MaterialType}
                                          required
                                          name={
                                            "WorkMeasureMaterialID" +
                                            "-" +
                                            index
                                          }
                                          className="edit_job_edit form__field_select"
                                          onChange={this.handleMaterialChange}
                                          defaultValue={materials.value}
                                        >
                                          {materials.MaterialDetails.map(
                                            (materialdetails, indexoption) => (
                                              <option
                                                key={indexoption}
                                                value={
                                                  materialdetails.WorkMeasureMaterialId
                                                }
                                              >
                                                {materialdetails.MaterialName}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                      </FloatingLabel>
                                    </div>

                                    <div className="col-md-6 form-group input-user">
                                      {this.state.JobTypeID !== 3 &&
                                      this.state.JobTypeID !== 10 ? (
                                        <FloatingLabel
                                          className=""
                                          key={index + 1}
                                          label={
                                            materials.Required === 1 &&
                                            selectedTenantData.Tenant !==
                                              "Thisco"
                                              ? materials.UoM !== ""
                                                ? materials.MaterialType +
                                                  " (" +
                                                  materials.UoM +
                                                  ") *"
                                                : materials.MaterialType + " *"
                                              : materials.UoM !== ""
                                              ? materials.MaterialType +
                                                " (" +
                                                materials.UoM +
                                                ")"
                                              : materials.MaterialType
                                          }
                                        >
                                          <Form.Control
                                            className="edit_job_edit form__field"
                                            type="number"
                                            required={
                                              selectedTenantData.Tenant !==
                                                "Thisco" &&
                                              materials.Required === 1
                                                ? true
                                                : false
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            name={"value" + "-" + index}
                                            onChange={
                                              materials.DataType === "Int"
                                                ? this
                                                    .handleNumberMaterialChange
                                                : materials.DataType === "Dec1"
                                                ? this.changeMaterialsDec
                                                : this.changeMaterials
                                            }
                                            placeholder={
                                              materials.UoM !== ""
                                                ? materials.MaterialType +
                                                  " (" +
                                                  materials.UoM +
                                                  ")"
                                                : materials.MaterialType
                                            }
                                            value={
                                              index === 0 &&
                                              this.state
                                                .materialsdatamainwone !==
                                                undefined
                                                ? this.state
                                                    .materialsdatamainwone
                                                : index === 1 &&
                                                  this.state
                                                    .materialsdatamainwtwo !==
                                                    undefined
                                                ? this.state
                                                    .materialsdatamainwtwo
                                                : index === 2 &&
                                                  this.state
                                                    .materialsdatamainwthree !==
                                                    undefined
                                                ? this.state
                                                    .materialsdatamainwthree
                                                : index === 3 &&
                                                  this.state
                                                    .materialsdatamainwfour !==
                                                    undefined
                                                ? this.state
                                                    .materialsdatamainwfour
                                                : index === 4 &&
                                                  this.state
                                                    .materialsdatamainwfive !==
                                                    undefined
                                                ? this.state
                                                    .materialsdatamainwfive
                                                : index === 5 &&
                                                  this.state
                                                    .materialsdatamainwsix !==
                                                    undefined
                                                ? this.state
                                                    .materialsdatamainwsix
                                                : materials.MaterialDetails.find(
                                                    (materialdetail) =>
                                                      materialdetail.WorkMeasureMaterialId ===
                                                      materials.value
                                                  )?.value || ""
                                            }
                                            step={
                                              materials.DataType === "Int"
                                                ? ""
                                                : "0.0000001"
                                            }
                                          />
                                        </FloatingLabel>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )
                              )
                          : ""}

                        {this.state.materialsData !== "" &&
                        this.state.showMaterial.length > 0
                          ? this.state.materialsData.map((materials, index) =>
                              materials.MaterialDetails.length === 1 ? (
                                <>
                                  {materials.DataType === "Char" &&
                                  materials.MaterialName === "Other" ? (
                                    <FloatingLabel
                                      key={index}
                                      className="lableWidth in"
                                      label={
                                        materials.Required === 1
                                          ? materials.UoM !== ""
                                            ? materials.MaterialType +
                                              " (" +
                                              materials.UoM +
                                              ") *"
                                            : materials.MaterialType + " *"
                                          : materials.UoM !== ""
                                          ? materials.MaterialType +
                                            " (" +
                                            materials.UoM +
                                            ")"
                                          : materials.MaterialType
                                      }
                                    >
                                      <Form.Control
                                        className="edit_job_edit form__field"
                                        type="text"
                                        key={index}
                                        maxLength="100"
                                        required={
                                          materials.Required === 1
                                            ? true
                                            : false
                                        }
                                        name={
                                          "value" +
                                          "-" +
                                          materials.MaterialDetails[0]
                                            .WorkMeasureMaterialId +
                                          "-" +
                                          index +
                                          "-" +
                                          materials.MaterialDetails[0]
                                            .JobMeasureMaterialID
                                        }
                                        onChange={
                                          this.handleMaterialChangeOther
                                        }
                                        value={
                                          index === 0
                                            ? this.state.materialsdatamainone
                                            : index === 1
                                            ? this.state.materialsdatamaintwo
                                            : index === 2
                                            ? this.state.materialsdatamainthree
                                            : index === 3
                                            ? this.state.materialsdatamainfour
                                            : index === 4
                                            ? this.state.materialsdatamainfive
                                            : index === 5
                                            ? this.state.materialsdatamainsix
                                            : ""
                                        }
                                        placeholder={materials.MaterialType}
                                      />
                                    </FloatingLabel>
                                  ) : (
                                    <div
                                      className="rowUser rowUserData mt-4"
                                      key={index}
                                      style={{
                                        display:
                                          materials.value !== undefined &&
                                          materials.value !== null
                                            ? "flex"
                                            : "none", // Conditionally hide the row if 'value' is undefined or null
                                      }}
                                    >
                                      <div className="col-md-6 form-group input-user">
                                        <FloatingLabel
                                          className=""
                                          label={
                                            materials.Required === 1 &&
                                            selectedTenantData.Tenant !==
                                              "Thisco"
                                              ? "Select Type of " +
                                                materials.MaterialType +
                                                " *"
                                              : "Select Type of " +
                                                materials.MaterialType
                                          }
                                          key={index}
                                        >
                                          <Form.Select
                                            aria-label={materials.MaterialType}
                                            required
                                            name={
                                              "WorkMeasureMaterialID" +
                                              "-" +
                                              index
                                            }
                                            className="edit_job_edit form__field_select"
                                            onChange={this.handleMaterialChange}
                                            defaultValue={materials.value}
                                          >
                                            {materials.MaterialDetails.map(
                                              (
                                                materialdetails,
                                                indexoption
                                              ) => (
                                                <option
                                                  key={indexoption}
                                                  value={
                                                    materialdetails.WorkMeasureMaterialId
                                                  }
                                                >
                                                  {materialdetails.MaterialName}
                                                </option>
                                              )
                                            )}
                                          </Form.Select>
                                        </FloatingLabel>
                                      </div>

                                      <div className="col-md-6 form-group input-user">
                                        {this.state.JobTypeID !== 3 &&
                                        this.state.JobTypeID !== 10 ? (
                                          <FloatingLabel
                                            className=""
                                            key={index + 1}
                                            label={
                                              materials.Required === 1 &&
                                              selectedTenantData.Tenant !==
                                                "Thisco"
                                                ? materials.UoM !== ""
                                                  ? materials.MaterialType +
                                                    " (" +
                                                    materials.UoM +
                                                    ") *"
                                                  : materials.MaterialType +
                                                    " *"
                                                : materials.UoM !== ""
                                                ? materials.MaterialType +
                                                  " (" +
                                                  materials.UoM +
                                                  ")"
                                                : materials.MaterialType
                                            }
                                          >
                                            <Form.Control
                                              className="edit_job_edit form__field"
                                              type="number"
                                              required={
                                                selectedTenantData.Tenant !==
                                                  "Thisco" &&
                                                materials.Required === 1
                                                  ? true
                                                  : false
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              name={"value" + "-" + index}
                                              onChange={
                                                materials.DataType === "Int"
                                                  ? this
                                                      .handleNumberMaterialChange
                                                  : materials.DataType ===
                                                    "Dec1"
                                                  ? this.changeMaterialsDec
                                                  : this.changeMaterials
                                              }
                                              placeholder={
                                                materials.UoM !== ""
                                                  ? materials.MaterialType +
                                                    " (" +
                                                    materials.UoM +
                                                    ")"
                                                  : materials.MaterialType
                                              }
                                              value={
                                                index === 0 &&
                                                this.state
                                                  .materialsdatamainwone !==
                                                  undefined
                                                  ? this.state
                                                      .materialsdatamainwone
                                                  : index === 1 &&
                                                    this.state
                                                      .materialsdatamainwtwo !==
                                                      undefined
                                                  ? this.state
                                                      .materialsdatamainwtwo
                                                  : index === 2 &&
                                                    this.state
                                                      .materialsdatamainwthree !==
                                                      undefined
                                                  ? this.state
                                                      .materialsdatamainwthree
                                                  : index === 3 &&
                                                    this.state
                                                      .materialsdatamainwfour !==
                                                      undefined
                                                  ? this.state
                                                      .materialsdatamainwfour
                                                  : index === 4 &&
                                                    this.state
                                                      .materialsdatamainwfive !==
                                                      undefined
                                                  ? this.state
                                                      .materialsdatamainwfive
                                                  : index === 5 &&
                                                    this.state
                                                      .materialsdatamainwsix !==
                                                      undefined
                                                  ? this.state
                                                      .materialsdatamainwsix
                                                  : materials.MaterialDetails.find(
                                                      (materialdetail) =>
                                                        materialdetail.WorkMeasureMaterialId ===
                                                        materials.value
                                                    )?.value || ""
                                              }
                                              step={
                                                materials.DataType === "Int"
                                                  ? ""
                                                  : "0.0000001"
                                              }
                                            />
                                          </FloatingLabel>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                ""
                              )
                            )
                          : ""}

                        <h1 className="headingClass">Manpower</h1>
                        <div className="rowData rowUserData">
                          <div className="col-md-4 form-group input-user select_data">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant=" primary"
                                className="navbutton"
                                id="dropdown-basic"
                                ref={this.textInput}
                              >
                                Technician(s)
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropMainClass">
                                <table className="table tabletech table-hover">
                                  <thead className="">
                                    {this.state.techDataMain !== "" &&
                                    this.state.techDataMain !== null
                                      ? this.state.techDataMain.map(
                                          (techData, index) => (
                                            <tr>
                                              <th
                                                className="techac"
                                                key={index + "ac"}
                                              >
                                                <input
                                                  type="checkbox"
                                                  className="techcheck"
                                                  onClick={this.handleDataChangeTech(
                                                    index
                                                  )}
                                                  defaultChecked={
                                                    techData.check
                                                  }
                                                  value={techData.id}
                                                />
                                              </th>
                                              <th
                                                className={`techac ${
                                                  techData.IsValid
                                                    ? " "
                                                    : " techRed"
                                                }`}
                                                key={index + "id"}
                                              >
                                                {techData.IsTrainee === true
                                                  ? techData.name + " [Trainee]"
                                                  : techData.name}
                                              </th>
                                              <th
                                                className="techac"
                                                key={index + "per"}
                                              >
                                                <input
                                                  type="text"
                                                  onChange={this.handleDataChangeTechOther(
                                                    index
                                                  )}
                                                  disabled={techData.IsTrainee}
                                                  className=" techdataclen"
                                                  value={techData.pcdata}
                                                  name={"techper" + index}
                                                />{" "}
                                              </th>
                                            </tr>
                                          )
                                        )
                                      : ""}
                                  </thead>
                                </table>
                              </Dropdown.Menu>
                            </Dropdown>
                            {this.state.isError.TechnicianName !== "" ? (
                              <span className="tool_tip">
                                {this.state.isError.TechnicianName}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="col-md-4 form-group input-user">
                            <FloatingLabel
                              controlId="floatingSelectGrid"
                              className="lableWidth"
                              label="Number of Casual(s) * "
                            >
                              <Form.Control
                                type="number"
                                required
                                name="NumberOfCasuals"
                                value={this.state.NumberOfCasuals}
                                onWheel={(e) => e.target.blur()}
                                onChange={this.handleNumberCasChange}
                                placeholder="Number of Casual(s) * "
                                className="edit_job_edit form__field"
                              />
                              {this.state.isError.NumberOfCasuals !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.NumberOfCasuals}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                        </div>
                        <p className="techList">
                          {TechnicianNameArr.length > 0
                            ? TechnicianNameArr.reduce((prev, curr) => [
                                prev,
                                ", ",
                                curr,
                              ])
                            : ""}
                        </p>

                        <div className="rowData rowUserData">
                          <div className="col-md-12 form-group input-user select_data">
                            <FloatingLabel
                              className="font_size"
                              label="Remarks *"
                            >
                              <Form.Control
                                type="text"
                                name="Remarks"
                                ref={this.remarkInput}
                                onChange={this.handleDataChangeOther}
                                placeholder="Remarks"
                                className="form__field"
                                value={this.state.Remarks}
                              />
                            </FloatingLabel>
                          </div>
                        </div>
                        <div className="rowData rowUserData">
                          <div className="col-md-3 form-group input-user">
                            <Form.Check
                              type="checkbox"
                              className="edit_job_edit form__field font_size"
                              checked={this.state.IncludeMtrl}
                              name="IncludeMtrl"
                              onChange={this.handleChangeCheck}
                              value={this.state.IncludeMtrl}
                              label="Include Material"
                            />
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <Form.Check
                              type="checkbox"
                              className="edit_job_edit form__field font_size"
                              checked={this.state.OnlyCasuals}
                              name="OnlyCasuals"
                              onChange={this.handleChangeCheck}
                              value={this.state.OnlyCasuals}
                              label="Only Casuals"
                            />
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <Form.Check
                              type="checkbox"
                              className="edit_job_edit form__field font_size"
                              checked={this.state.UG}
                              name="UG"
                              onChange={this.handleChangeCheck}
                              value={this.state.UG}
                              label="UG"
                            />
                          </div>
                          {selectedTenantData.Tenant === "Thisco" ? (
                            <div className="col-md-3 form-group input-user">
                              <Form.Check
                                type="checkbox"
                                className="edit_job_edit form__field font_size"
                                checked={this.state.Factory}
                                name="Factory"
                                onChange={this.handleChangeCheck}
                                value={this.state.Factory}
                                label="Factory"
                              />
                            </div>
                          ) : null}
                        </div>
                        <div className="rowData">
                          <div className="col-md-3 form-group input-user">
                            <button
                              type="submit"
                              onClick={(event) =>
                                this.setState({ submitvalue: "10" })
                              }
                              className="btnvalsubmit btn btn-success font_size"
                            >
                              Save
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <button
                              type="submit"
                              name="submitvalue"
                              value="80"
                              onClick={(event) =>
                                this.setState({ submitvalue: "80" })
                              }
                              className="btnvalsubmit btn btn-dark font_size"
                            >
                              Hold
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <button
                              type="submit"
                              value="70"
                              onClick={(event) =>
                                this.setState({ submitvalue: "70" })
                              }
                              className="btnvalsubmit btn btn-danger font_size"
                            >
                              Reject
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            {this.state.Permission === "VALIDATE_JOB" ? (
                              <button
                                type="submit"
                                value="60"
                                onClick={(event) =>
                                  this.setState({ submitvalue: "60" })
                                }
                                className="btnvalsubmit btn btn-primary font_size"
                              >
                                Validate
                              </button>
                            ) : (
                              ""
                            )}
                            {this.state.Permission === "AUTHORIZE_JOB" &&
                            this.state.submitbtn === true &&
                            StatusValue.some(
                              (element) => element === this.state.statusId
                            ) === true ? (
                              <button
                                type="submit"
                                value="90"
                                onClick={(event) =>
                                  this.setState({ submitvalue: "90" })
                                }
                                className="btnval btn btn-success font_size"
                              >
                                Authorize
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* <div className="col-md-4 form-group input-user">
                                <button type="button" onClick={this.handleClose} className="btnval btn btn-warning font_size">
                                    Discard
                                </button>
                              </div> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </span>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    );
  }
}
